/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
import * as R from 'ramda';

/**
 * The internal dependencies.
 */

const InputWrapper = styled.div`
	background: #fff;
	border-radius: 5px;

	& a {
		display: block;
		text-decoration: none;
		color: #43aaf1;
		// padding: 8px 18px 9px 11px;
	}

	& li.selected,
	& a {
		// font-size: 16px;
	}
`;

const ListWrapper = styled.div`
	position: absolute;
	z-index: 10;
	background: #fff;
	padding: 0 11px 0 27px;
	border-radius: 5px;
	width: 200px;

	& li {
		font-size: 14px;
		padding: 7px 0;
		border-color: #D5D6D7;
	}
`;

const List = styled.ul`
	flex: 0 1 ${({width}) => width ? width : '100%'};
	list-style: none outside;
	overflow: auto;
	${({isreport}) => isreport ? 'max-height: 250px;' : 'max-height: 400px;'}
`;

const ListItem = styled.li`
	font-size: 19px;
	color: ${({selected}) => selected ? '#43abf3' : '#3b3b3b'};
	padding-bottom: 15px;
	cursor: pointer;

	& + li {
		padding-top: 25px;;
		border-top: 1px solid #95989a;
	}
`;

const FilterInput = styled.input`
    color: #686871;
    padding: 1px;
`;

class InputAutocomplete extends React.Component {
    constructor() {
        super();

        this.state = {
            expanded: null,
        }

        this.changeValue = this.changeValue.bind(this);
    }

    toggle() {
        const {expanded} = this.state;
        this.setState({expanded: !expanded})
    }

    changeValue = (event) => {
        const {onChange, requestOptions} = this.props;
        // console.log("Value", event.target.value);
        // this.setState({value: event.target.value});
        if (R.length(event.target.value) > 2) {
            requestOptions(event.target.value).finally(() => {
                this.setState({expanded: true})
            });
        } else {
            this.setState({expanded: false})
        }
        onChange(event.target.value);
    };

    handleSelect = (value) => {
        const {onChange, onSelect} = this.props;
        this.toggle();
        // this.setState({value: value});
        onChange(value);
        setTimeout(() => {
            onSelect();
        }, 100);

    };

    render() {
        const {expanded} = this.state;
        const {options, onKeyDown, value} = this.props;

        return (
            <InputWrapper>
                <FilterInput value={value} onChange={this.changeValue} onKeyDown={onKeyDown}/>

                {expanded
                    ? (
                        <ListWrapper>

                            <List>
                                {options.map((option, index) => (
                                    <ListItem
                                        key={`list-item-${index}`}
                                        onClick={() => this.handleSelect(option)}
                                        selected={option === value}
                                        className={`${option === value ? 'selected' : ''}`}
                                    >
                                        {option}
                                    </ListItem>
                                ))}
                            </List>

                        </ListWrapper>
                    )
                    : <span></span>
                }
            </InputWrapper>
        );
    }
}

export default InputAutocomplete;



// WEBPACK FOOTER //
// ./src/components/dashboard/bar/inputautocomplete.js